import React, { Component } from 'react';
import { startCase } from 'lodash';
import DropDown from '~/components/shared/drop_down';
import BinIcon from '~/images/bin.svg';
import Input from '~/components/shared/input_field';
import I18n from '~/utils/translations';

export default class AppendableCharge extends Component {
  getChargeOptions = (selectedDescription) => {
    const { portfolioCharges, inputValues } = this.props;
    const selectedDescriptions = inputValues.map((charge) => charge.description);

    return portfolioCharges
      .filter(
        (charge) =>
          !selectedDescriptions.includes(charge.attributes.description) ||
          charge.attributes.description === selectedDescription
      )
      .map((charge) => ({
        value: charge.attributes.description,
        label: startCase(charge.attributes.description),
      }));
  };

  handleChargeChange = (index, value) => {
    const updatedValues = [...this.props.inputValues];
    const selectedCharge = this.props.portfolioCharges.find((charge) => charge.attributes.description === value);

    if (selectedCharge) {
      const amount = selectedCharge.attributes.amount
        ? (Number(selectedCharge.attributes.amount) / 100).toFixed(2)
        : '';
      updatedValues[index] = {
        description: selectedCharge.attributes.description,
        amount: amount,
        part_of_referencing: selectedCharge.attributes.part_of_referencing,
      };

      this.props.onChange(updatedValues);
    }
  };

  handleAmountChange = (index, value) => {
    const updatedValues = [...this.props.inputValues];
    updatedValues[index].amount = value;
    this.props.onChange(updatedValues);
  };

  handleAmountBlur = (index, evt) => {
    let amount = evt.target.value;
    if (amount !== '' && !isNaN(amount)) {
      amount = Number(amount).toFixed(2);
    }
    const updatedValues = [...this.props.inputValues];
    updatedValues[index].amount = amount;
    this.props.onChange(updatedValues);
  };

  handleAddCharge = () => {
    const newCharge = { description: '', amount: '' };
    this.props.onChange([...this.props.inputValues, newCharge]);
  };

  handleRemoveCharge = (index) => {
    const updatedValues = [...this.props.inputValues];
    updatedValues.splice(index, 1);
    this.props.onChange(updatedValues);
  };

  render() {
    const { inputValues, appendText, hint, errors } = this.props;

    return (
      <div className="appendable-charge">
        {inputValues.map((charge, index) => {
          const availableChargeOptions = this.getChargeOptions(charge.description);
          const chargeErrors = errors[index] || {};
          return (
            <div key={index} className="charge-input-group">
              <div className="dropdown-wrapper">
                <DropDown
                  placeholder={hint}
                  items={availableChargeOptions}
                  onChange={(e) => this.handleChargeChange(index, e.target.value)}
                  value={charge.description}
                  name="charge_description"
                  errors={chargeErrors.description}
                />
              </div>
              <Input
                name={`charge_amount_${index}`}
                type="text"
                animatedPlaceholder={I18n.t('pages.agents_form.charges.amount_placeholder')}
                prepend={I18n.t('currency.symbol')}
                value={charge.amount}
                onChange={(e) => this.handleAmountChange(index, e.target.value)}
                onBlur={(e) => this.handleAmountBlur(index, e)}
                errors={chargeErrors.amount}
              />
              <img
                src={BinIcon}
                alt="Remove"
                className="remove-charge-icon"
                onClick={() => this.handleRemoveCharge(index)}
              />
            </div>
          );
        })}

        {this.getChargeOptions().length > 0 && (
          <button onClick={this.handleAddCharge} className="append-button">
            {appendText}
          </button>
        )}
      </div>
    );
  }
}
